import { h, FunctionalComponent } from 'preact';
import { useRef, useCallback } from 'preact/hooks';

import { first } from 'libs/arrays';

interface IInputCaptureProps {
	cameraType: 'front' | 'back';
	className?: string;
	accept?: string[];
	onCapture: (file) => void;
}

export const InputCapture: FunctionalComponent<IInputCaptureProps> = (props) => {
	const input = useRef(null);

	const {
		children,
		className,
		accept = [],
		onCapture,
	} = props;

	const handleClick = useCallback(() => {
		if (input.current === null) {
			return;
		}

		input.current.click();
	}, [input]);

	const handleChange = useCallback(({ target }) => {
		if (target.files === null || target.files.length === 0) {
			return;
		}

		onCapture(first(target.files));
	}, [onCapture]);

	return (
		<div class={className} onClick={handleClick}>
			{children}
			<input
				ref={input}
				accept={accept.map(item => '.' + item).join(',')}
				onChange={handleChange}
				multiple={false}
				// @ts-ignore
				capture={props.cameraType === 'front' ? 'user' : 'environment'}
				type="file"
				hidden
			/>
		</div>
	)
};
